// Relative `.ts` imports, not `@/`: node's test runner can't resolve the alias.
// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import { detectInAppBrowser } from '../../lib/posthog/inAppBrowser.ts';
import { detectMobileOs } from './inAppHandoff.ts';

/** A desktop browser: not a phone or tablet, and not a social app's built-in browser. */
export const isDesktopBrowser = (userAgent: string, maxTouchPoints = 0) =>
  detectMobileOs(userAgent, maxTouchPoints) === 'other' &&
  detectInAppBrowser(userAgent) === 'none';
